import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "person-select-dialog-content" }
const _hoisted_2 = { class: "search-input" }
const _hoisted_3 = { class: "persons" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "department" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "level" }
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确 定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_button = _resolveComponent("el-button")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        placeholder: "请输入姓名",
        "prefix-icon": "el-icon-search",
        modelValue: _ctx.searchInput,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchInput = $event))
      }, null, 8, ["modelValue"])
    ]),
    _withDirectives(_createVNode("div", _hoisted_3, [
      _createVNode(_component_el_checkbox_group, {
        modelValue: _ctx.personIdSelected,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.personIdSelected = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.agents, (p) => {
            return (_openBlock(), _createBlock("div", {
              key: p.ldap,
              class: "checkbox-wrap"
            }, [
              _createVNode(_component_el_checkbox, {
                label: p.ldap
              }, {
                default: _withCtx(() => [
                  _createVNode("span", _hoisted_4, _toDisplayString(p.name), 1),
                  _createVNode("span", _hoisted_5, _toDisplayString(p.department), 1),
                  _createVNode(_component_el_tooltip, { placement: "top" }, {
                    content: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(p.tags, (t, i) => {
                        return (_openBlock(), _createBlock(_Fragment, { key: i }, [
                          _createTextVNode(_toDisplayString(t), 1),
                          (i !== p.tags.length - 1)
                            ? (_openBlock(), _createBlock("br", _hoisted_6))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]),
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_7, _toDisplayString(p.tags.join(',')), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["label"])
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 512), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit(_ctx.agentSelected)))
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ])
  ]))
}